/*
 * Noop.
 */

function noop() {
    // Do nothing
}

export default noop;
